import React, { useState, useEffect } from "react";
import { Table } from "@jdcfe/legao";
import { queryLimitPackageList } from "utils/api";
import { Link } from "react-router-dom";
import qs from "qs";

import "./style.scss";

const tableTitle = [
  {
    title: "文档名称",
    dataIndex: "articleName",
    key: "1",
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
    key: "2",
    width: 400,
  },
];

export default function SchemeList() {
  const [listData, setListData] = useState([]);
  // const history = useHistory();

  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { appKey, authId, authPackName } = query;

  // const handleRowClick = (data) => {
  //   history.push(
  //     `/app/frame/schemedetail?appKey=${appKey}&authId=${authId}&authPackName=${encodeURIComponent(
  //       authPackName
  //     )}&articleId=${data.key}`
  //   );
  // };

  useEffect(() => {
    queryLimitPackageList({
      appKey: query.appKey,
      authId: query.authId,
    }).then((res) => {
      if (res.data.success) {
        const resData = [];
        res.data.result.forEach((item) => {
          resData.push({
            articleName: (
              <Link
                to={`/app/frame/schemedetail?appKey=${appKey}&authId=${authId}&authPackName=${encodeURIComponent(
                  authPackName
                )}&articleId=${item.articleId}`}
                onClick={() => {log('vop_open_pc', 'vop_open_console_package', query.authId,item.articleId);}}
              >
                {item.articleName}
              </Link>
            ),
            updateTime: item.updateTime,
            key: item.articleId,
          });
        });
        setListData(resData);
      }
    });
  }, []); //eslint-disable-line

  return (
    <div className="scheme_list">
      <div className="scheme_top">
        <span className="title">{query.authPackName}对接方案</span>
      </div>
      <div className="scheme_content">
        <Table
          className="per_table"
          columns={tableTitle}
          data={listData}
          emptyText={"已选条件下暂无数据，请更换筛选条件"}
        />
      </div>
    </div>
  );
}
